import React from 'react';

const SVGBDComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height={512}
    viewBox="0 0 512 512"
    width={512}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path
            d="m387.975 357.573c0 85.288-68.128 154.427-152.167 154.427s-152.167-69.139-152.167-154.427c0-70.176 103.021-200.34 139.528-244.264 6.573-7.908 18.705-7.908 25.277 0 36.508 43.924 139.529 174.088 139.529 244.264z"
            fill="#B0F6FFFF"
          />
          <path
            d="m248.447 113.309c-3.286-3.954-7.962-5.931-12.639-5.931v404.622c84.039 0 152.167-69.139 152.167-154.427 0-70.176-103.021-200.341-139.528-244.264z"
            fill="#00C1FCFF"
          />
        </g>
        <g>
          <path
            d="m270.295 314.69h-19.486v-19.486c0-8.284-6.716-15-15-15s-15 6.716-15 15v19.486h-19.486c-8.284 0-15 6.716-15 15s6.716 15 15 15h19.486v19.486c0 8.284 6.716 15 15 15s15-6.716 15-15v-19.486h19.486c8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15z"
            fill="#f9f2f2"
          />
          <path
            d="m270.295 314.69h-19.486v-19.486c0-8.284-6.716-15-15-15v98.972c8.284 0 15-6.716 15-15v-19.486h19.486c8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15z"
            fill="#e7e2ee"
          />
        </g>
      </g>
      <g>
        <path
          d="m428.359 90.908c0 32.934-26.698 59.632-59.632 59.632s-59.632-26.698-59.632-59.632c0-23.078 29.281-62.956 46.806-84.758 6.592-8.201 19.059-8.201 25.651 0 17.526 21.802 46.807 61.681 46.807 84.758z"
          fill="#6BA6FFFF"
        />
        <path
          d="m381.552 6.15c-3.296-4.1-8.061-6.15-12.825-6.15v150.54c32.934 0 59.632-26.698 59.632-59.632 0-23.077-29.281-62.956-46.807-84.758z"
          fill="#0066FFFF"
        />
      </g>
    </g>
  </svg>
);
export default SVGBDComponent;
